import React from 'react';

export default function DepthIndicator({ currentZone }) {
  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 
                    bg-white bg-opacity-80 text-gray-900 
                    px-6 py-2 rounded-full shadow-lg z-50 text-center">
      <div className="text-sm uppercase tracking-wide font-semibold">
        {currentZone.name}
      </div>
      <div className="text-lg font-bold">
        Depth: {currentZone.depthRange[0]}–{currentZone.depthRange[1]} m
      </div>
    </div>
  );
}
